(function() {
    angular
        .module("feedbackModule", [
            "ui.router"
        ])
})()
